import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { StyleSheet, css } from 'aphrodite'
import { useTranslation } from 'react-i18next'
import { COLOR_WHITE, COLOR_BLACK } from '../../lib/colors'
import Slider from 'react-slick'
import chevron from '../../assets/chevron.svg'
import UIButtonIcon from '../../components/UI/UIButtonIcon'
import pods from '../../assets/pods.svg'
import smart from '../../assets/l_smartphone.svg'
import bat from '../../assets/batterie.svg'
import veste from '../../assets/veste.svg'
import { BP_XS } from '../../lib/breakpoints'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: 0,
    overflow: 'hidden',
    color: COLOR_WHITE,
    fontWeight: 700,
    letterSpacing: '-0.05em',
    padding: '3em 8em',
    background: COLOR_WHITE,
    paddingLeft: '0',
    '@media (max-width: 480px)': {
      margin: '0',
      padding: '80px 20px 40px 20px',
    },
  },
  containerTitle: {
    display: 'flex',
    marginBottom: '2em',
    '@media (max-width: 480px)': {
      flexDirection: 'column',
    },
  },
  title: {
    margin: 0,
    fontSize: '2em',
    color: COLOR_BLACK,
    fontWeight: 700,
    marginRight: '0.3em',
    paddingLeft: '10%',
    '@media (max-width: 480px)': {
      fontSize: '2em',
    },
  },
  containerItem: {
    width: '300px',
    height: '200px',
    padding: '10%',
    textAlign: 'center',
    backgroundColor: '#FAFAFA',
    color: COLOR_BLACK,
    borderRadius: '10px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 480px)': {
      width: '170px',
      height: '200px',
      padding: '10px',
    },
  },
  itemText: {
    fontSize: '1.2em',
  },
  containerChevron: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    marginTop: '2em',
    color: '',
  },
  chevronLeft: {
    filter: 'invert(1)',
    transform: 'scale(-1, -1)',
    cursor: 'pointer',
    width: '2em',
  },
  chevronRight: {
    filter: 'invert(1)',
    cursor: 'pointer',
    width: '2em',
  },
  containerSlider: {
    width: '100vw',
    fontWeight: 700,
    '@media (max-width: 480px)': {
      width: 'auto',
    },
  },
})

const Optimization = () => {
  const { t } = useTranslation('translation')
  const slider = useRef()

  const settings = {
    centerMode: true,
    infinite: true,
    speed: 500,
    swipe: true,
    arrows: false,
  }

  const listItems = [
    {
      title: 'Un téléphone en bon état',
      image: smart,
    },
    {
      title: 'La batterie chargée',
      image: bat,
    },
    {
      title: 'Des écouteurs',
      image: pods,
    },
    {
      title: 'Votre gilet pour être identifié',
      image: veste,
    },
  ]

  const next = () => {
    slider.current.slickNext()
  }

  const previous = () => {
    slider.current.slickPrev()
  }

  return (
    <>
      <div id="optimization" className={css(styles.container)}>
        <div className={css(styles.containerTitle)}>
          <p className={css(styles.title)}>{t('pages.beAMaker.needTitle')}</p>
        </div>
        <div className={css(styles.containerSlider)}>
          <Slider
            ref={slider}
            {...settings}
            slidesToShow={
              window.innerWidth < 1024 ? (window.innerWidth < BP_XS ? 1 : 2) : 3
            }
          >
            {listItems.map(({ title, image }, index) => (
              <Item key={index} preview={image} title={title} />
            ))}
          </Slider>
        </div>
        <div className={css(styles.containerChevron)}>
          <UIButtonIcon onClick={previous}>
            <img
              src={chevron}
              className={css(styles.chevronLeft)}
              alt="chevron left"
              width="2em"
              height="auto"
            />
          </UIButtonIcon>
          <UIButtonIcon onClick={next}>
            <img
              src={chevron}
              className={css(styles.chevronRight)}
              alt="chevron right"
              width="2em"
              height="auto"
            />
          </UIButtonIcon>
        </div>
      </div>
    </>
  )
}

const Item = ({ title, preview }) => {
  return (
    <div className={css(styles.containerItem)}>
      <img
        src={preview}
        alt="item needed illustation"
        width="auto"
        height="auto"
      />
      <p className={css(styles.itemText)}>{title}</p>
    </div>
  )
}

Item.propTypes = {
  title: PropTypes.string,
  preview: PropTypes.string,
}

export default Optimization
